import React from 'react'
import ErrorFeature from '../../components/error-feature'
import HttpStatusCode from '../../../server/lib/http-codes'
import WestfieldDirectLayout from '../../components/westfield-direct/layout'

interface IErrorPageProps {
  errorMessage?: string
  statusCode?: HttpStatusCode
}

const ErrorPage: React.FunctionComponent<
  React.PropsWithChildren<IErrorPageProps>
> = ({ errorMessage, statusCode = HttpStatusCode.NOT_FOUND }) => (
  <WestfieldDirectLayout
    component={() => (
      <ErrorFeature statusCode={statusCode} errorMessage={errorMessage} />
    )}
    topStrip={null}
  />
)

export default ErrorPage
